const maxAttributeLength = 200;
export const trimAttribute = (str, maxLength = maxAttributeLength, ellipsis = '...') => {
  const ellipsisLength = ellipsis.length;
  return str.length > maxLength ? `${str.substring(0, maxLength - ellipsisLength)}${ellipsis}` : str;
};
export const getDomain = () => {
  const {
    hostname
  } = window.location;
  return hostname.substring(hostname.lastIndexOf('.', hostname.lastIndexOf('.') - 1) + 1);
};